var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    { staticClass: "logoList" },
    [
      _c("ServiceLogo", {
        staticClass: "logoListItemHighSchool",
        attrs: { "image-src": "/images/contents/logo_study_sapuri_high.png" },
      }),
      _vm._v(" "),
      _c("ServiceLogo", {
        staticClass: "logoListItemUniversity",
        attrs: {
          "image-src": "/images/contents/logo_study_sapuri_university.png",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }